import { useState } from "react";
import * as yup from "yup";
import Breadcrumb from "../../components/breadcrumb/Breadcrumb";
import FormBody, { InputError, LevelReq } from "../../components/form/FormBody";
import PasswordField from "../../components/form/PasswordField";
import instance from "../../utils/api_instance.util";
import { adminPasswordRules } from "../../utils/validation.util";
import { errorToastify, successToastify } from "../../utils/toastify.util";

const schema = yup.object({
  currentPassword: yup.string().required("Current password is required"),
  password: adminPasswordRules,
  confirmpassword: yup
    .string()
    .required("Confirm password is required")
    .oneOf([yup.ref("password")], "Passwords do not match"),
});

const Settings = () => {
  const [saving, setSaving] = useState(false);

  const onSubmit = async (values, { resetForm }) => {
    if (saving) return;
    setSaving(true);
    try {
      const { data } = await instance.post("/api/v1/admin/auth/change-password", {
        currentPassword: values.currentPassword,
        password: values.password,
      });
      successToastify(data?.message || "Password updated.");
      resetForm();
    } catch (err) {
      errorToastify(
        err.response?.data?.message || "Unable to update password."
      );
    } finally {
      setSaving(false);
    }
  };

  return (
    <div id="main" className="main">
      <Breadcrumb page="Account Settings" />
      <section className="section">
        <div className="row">
          <div className="col-lg-6">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">Change Password</h5>
                <FormBody
                  initialValues={{
                    currentPassword: "",
                    password: "",
                    confirmpassword: "",
                  }}
                  validationSchema={schema}
                  onSubmit={onSubmit}
                >
                  <div className="mb-3">
                    <LevelReq htmlFor="currentPassword" className="form-label fs-7">
                      Current password
                    </LevelReq>
                    <PasswordField
                      id="currentPassword"
                      name="currentPassword"
                      autoComplete="current-password"
                    />
                    <InputError name="currentPassword" />
                  </div>
                  <div className="mb-3">
                    <LevelReq htmlFor="password" className="form-label fs-7">
                      New password
                    </LevelReq>
                    <PasswordField
                      id="password"
                      name="password"
                      autoComplete="new-password"
                    />
                    <InputError name="password" />
                  </div>
                  <div className="mb-3">
                    <LevelReq htmlFor="confirmpassword" className="form-label fs-7">
                      Confirm new password
                    </LevelReq>
                    <PasswordField
                      id="confirmpassword"
                      name="confirmpassword"
                      autoComplete="new-password"
                    />
                    <InputError name="confirmpassword" />
                  </div>
                  <button
                    className="btn btn-primary"
                    type="submit"
                    disabled={saving}
                  >
                    {saving ? "Saving..." : "Update password"}
                  </button>
                </FormBody>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Settings;
